import { useEffect, useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';
import { Announcement } from '@interfaces/general';

interface ActiveAnnouncementsResponse {
  data: Announcement[];
  plan: string;
}

export const useGetAnnouncement = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [plan, setPlan] = useState<string>('');

  const { isFetching, call } = useFetchCallback<undefined, ActiveAnnouncementsResponse>(
    'get',
    '/v1/announcement/active',
  );

  const fetchAnnouncements = async () => {
    try {
      const response = await call({});
      if (response) {
        setAnnouncements(response.data || []);
        setPlan(response.plan || '');
      }
    } catch {
      toast.error('Error al obtener los anuncios');
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  return {
    announcements,
    plan,
    isFetching,
    refetch: fetchAnnouncements,
  };
};
